import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { getCompletedPeriod } from "../../helpers/invoice";
import styles from "./InvoicePeriodWrapper.module.scss";

interface Props {
  isWithTransactions: boolean;
  startDate: string;
  endDate: string;
  count: number;
  invoiceNumber?: string;
}

const InvoicePeriodWrapper = ({
  isWithTransactions,
  startDate,
  endDate,
  count,
  invoiceNumber,
}: Props) => {
  const { t } = useTranslation();
  const getCustomLine = (label: string) =>
    invoiceNumber ? (
      <Link
        to={`/${
          isWithTransactions ? "transactions" : "transfers"
        }?invoiceNumber=${invoiceNumber}`}
      >
        {label}
      </Link>
    ) : (
      <span>{label}</span>
    );

  return (
    <div className={styles.invoicePeriodWrapper}>
      <span>
        {getCustomLine(
          t(
            `invoices.details.approved${
              isWithTransactions ? "Transactions" : "Transfers"
            }`,
            { count }
          )
        )}
      </span>
      <span>·</span>
      <span>{getCompletedPeriod(startDate, endDate)}</span>
    </div>
  );
};

export default InvoicePeriodWrapper;
